export default __webpack_public_path__ + "static/media/logo-horizontal-white.0791c2c1.svg";